import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTeamHierarchies } from '../../data/team-dao';
export const fetchTeamHierarchyAsyncThunk = createAsyncThunk('teams/hierarchy', async () => await getTeamHierarchies());